import { BaseModel } from "model/BaseModel";

export default class MarcaVeiculo implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;

    constructor(
        id = 0,
        codigo = null,
        nome = ''
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
    }

}